<template>
  <div id="centreLeft2">
    <el-dialog title="评分历史" :visible.sync="dialogFormVisible" width="70%">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column v-for="(item,index) in data" :key="index" :prop="item['prop']" :label="item['label']" :width="item['width']">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <div id="bottomLeftBarChart2" style="height: 3rem;width: 8rem;margin-top: .1rem;" @click="checkHistory"></div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      dialogFormVisible: false,
      listArr: [],
      tableData: [],
      data:[
        {prop: 'today_time',label: '时间',width: '130'},
        {prop: '一月',label: '一月'},
        {prop: '二月',label: '二月'},
        {prop: '三月',label: '三月'},
        {prop: '四月',label: '四月'},
        {prop: '五月',label: '五月'},
        {prop: '六月',label: '六月'},
        {prop: '七月',label: '七月'},
        {prop: '八月',label: '八月'},
        {prop: '九月',label: '九月'},
        {prop: '十月',label: '十月'},
        {prop: '十一月',label: '十一月'},
        {prop: '十二月',label: '十二月'},
      ]
    };
  },
  mounted() {
    this.draw();
  },
  created() {
    setTimeout(() => {
      this.getData(this.$store.state['scoreList'])
    }, 100)
  },
  computed: {
    listData() {
      return this.$store.state['scoreList']
    }
  },
  watch: {
    listData(data) {
      this.getData(data)
    }
  },
  methods: {
    checkHistory(){
      axios({
        url: `http://115.190.8.169:5000/get_score_data`,
        method: 'GET'
      }).then(res => {
        if (res.data != '网络错误' && res.data.length) {
          this.tableData = res.data
        }
      })
      this.dialogFormVisible = true
    },
    getData(data) {
      console.log(data,'data')
      var listArr = []
      this.listArr = []
      data.forEach((item,index) => {
        delete item['id']
        delete item['today_time']
        listArr.push([])
        listArr[index].push(item['一月'],item['二月'],item['三月'],item['四月'],item['五月'],item['六月'],item['七月'],item['八月'],item['九月'],item['十月'],item['十一月'],item['十二月'],)
      })
      const labelOption = {
        rotate: 90,
        align: 'left',
        verticalAlign: 'middle',
        position: 'insideBottom',
        distance: 15
      };
      listArr.forEach((k,i) => {
        this.listArr.push({
            name: `数据${i+1}`,
            type: 'bar',
            barGap: 0,
            label: labelOption,
            showAllSymbol: true,
            emphasis: {
              focus: 'series'
            },
            // itemStyle: {
            //   normal: {
            //     color: "#8ab3dc",
            //   },
            // },
            data: k
        })
      })
      console.log(this.listArr,'ddd')
      this.draw()
    },
    draw() {
      if (this.chart) { this.chart.clear() }
      // 基于准备好的dom，初始化echarts实例
      this.chart = this.$echarts.init(
        document.getElementById("bottomLeftBarChart2")
      );

      let option = {
        title: {
          text: '综合运输管理评分情况',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        toolbox: {
          show: false,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar', 'stack'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false },
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: this.listArr
      };
      this.chart.setOption(option);
    },
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style lang="scss" scoped>
#centreLeft2 {
  margin-right: 0.2rem;
  box-sizing: border-box;
  padding: 0.2rem 0;
  border-radius: 0.0625rem;

  .bg-color-black {
    height: 4.5125rem;
    border-radius: 0.125rem;
  }

  .text {
    color: #c3cbde;
    font-size: 0.18rem;
  }

  .chart-box {
    margin-top: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;

    .active-ring-name {
      padding-top: 0.125rem;
    }
  }
}
</style>